import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Value } from "baseui/select";
import { colors, glyphs, useMediaQuery } from "../../../Styles";
import { SelectField } from "../..";
import { field, FilterContent, FilterDisplayType, FilterDisplayEnum, FieldTypes } from "../../../Definitions";

import { AnimalGroupData } from "../../../Assets/TestData/animalGroups";
import { TestData as FeedCurveData } from "../../../Assets/TestData/feedCurvesData";
import { LocationData } from "../../../Assets/TestData/locations";

// #region | Data: Select Parameters
export const selectParameters: FilterDisplayType[] = [
  {label: "animalId", id: 1, displayType: FilterDisplayEnum.range},
  { label: "Location", id: 2, displayType: FilterDisplayEnum.select, options: LocationData.map(location => ({
    label: location.locationName,
    id: location.locationId
  }))},
  {label: "feedCurveNo", id: 3, displayType: FilterDisplayEnum.select, options: FeedCurveData.map(feedCurve => ({
    label: feedCurve.name,
    id: feedCurve.id
  }))},
  {label: "groupId", id: 4, displayType: FilterDisplayEnum.select, options: AnimalGroupData.map(group => ({
    label: group.groupName,
    id: group.groupId
  }))},
]
// #endregion

export default function QuickEntryModalLvl2() {
  const {t} = useTranslation()
  const mobileXs = useMediaQuery(`(max-width: 690px)`);
  const [selectFields, setSelectFields] = useState<field[]>([{ id: -1 }]);
  
  // SelectField Options
  const filterParamOptions = selectParameters.map((type) => ({
    label: t(`report.filterParameter.${type.label}`, {defaultValue: type.label}), 
    id: type.id
  }));
  
  // Handle onChange on SelectField
  const handleFilterTypeChange = (index: number, value: Value) => {
    const updatedSelectFields = [...selectFields];
    if (value.length > 0) {

      if (updatedSelectFields[index].id === -1) {
        updatedSelectFields.push({id: -1})
      }
      updatedSelectFields[index] = {id: value[0].id ? +value[0].id : 0, value: undefined};
    } else {
      updatedSelectFields[index].id = undefined;
    }
    setSelectFields(updatedSelectFields);
  };

  const handleFilterValueChange = (index?: number, value?: Value) => {
    const updatedSelectFields = [...selectFields];
    if (index && value && value.length > 0) {
      updatedSelectFields[index].value = value[0].id ? +value[0].id : 0;
    }
    setSelectFields(updatedSelectFields);
  }

  // Function to remove a SelectField by index
  const handleRemoveField = useCallback((index: number) => {
    const oldSelectedFields = [...selectFields];
    oldSelectedFields.splice(index, 1)
    setSelectFields(oldSelectedFields)
  },[selectFields]);

  const renderedFields = selectFields.map((field, index) => {return (
    <div key={index} style={{ 
      width: "100%", 
      display: "flex", 
      flexDirection: "column", 
      gap: "10px", 
      marginBottom: index === selectFields.length - 1 ? "0px" : "20px"
    }}>
      <div style={{ display: "flex", flexDirection: "row", gap: "20px", alignItems: "center", justifyContent: "space-between" }}>
        <SelectField
          placeholder={t("select")+"..."}
          key={index+String(field.id)}
          options={filterParamOptions}
          onChange={(value) => handleFilterTypeChange(index, value)}
          defaultValue={filterParamOptions.find((parameter) => {
            return parameter.id === field.id
          })?.label}
          overrides={{
            fieldType: FieldTypes.primaryInputField,
            textStart: true,
            fieldWidth: mobileXs ? "180px" : "280px",
            dropdownWidth: "280px",
            dropdownBorderRadius: mobileXs ? "0px 10px 10px 10px" : "0px 0px 10px 10px"
          }}
        />
        {field.id !== -1 && ( <>
            <div style={{cursor: "pointer"}} onClick={() => handleRemoveField(index)}>
              <glyphs.Delete size="25px"/>
            </div>
        </> )}
      </div>
      {/* Content based on selected filter parameter */}
      {field.id !== -1 && (
        <FilterContent filter={field} index={index} filterParameterTypes={selectParameters} handleFilterValueChange={handleFilterValueChange} />
      )}
    </div>
  )})
  // #endregion
  
  return(
    <div style={{ width: mobileXs ? "290px" : "600px" }}>
      <div style={{
        borderTop: "2px solid " + colors.blueDarkSecondary,
        borderBottom: "2px solid " + colors.blueDarkSecondary,
        padding: mobileXs? "10px 0px" : "10px",
        maxHeight: mobileXs ? "40vh" : "50vh",
        overflowY: "scroll",
        overflowX: "hidden",
        scrollbarWidth: "thin",
        scrollbarColor: colors.blueDarkSecondary+colors.transparent,
        display: "flex",
        alignItems: "center",
        justifyContent: "start",
        flexDirection: "column",
        gap: "10px"
      }}>
        {renderedFields}
      </div>
    </div>
  )
}